import React from 'react';
import './TimeLimit.less';
import autobind from 'autobind-decorator';
import { getTimeDifference } from '../../../utils';
import { observer } from 'mobx-react';

const TimeComp = (props) => {
    const h: any = getTimeDifference(props.date).hours < 10 ? `0${getTimeDifference(props.date).hours}` : getTimeDifference(props.date).hours;
    const s: any = getTimeDifference(props.date).minutes < 10 ? `0${getTimeDifference(props.date).minutes}` : getTimeDifference(props.date).minutes;
    const m: any = getTimeDifference(props.date).seconds < 10 ? `0${getTimeDifference(props.date).seconds}` : getTimeDifference(props.date).seconds;
    return (
        <div className={`${props.prefixCls}-timeBox`}>
            <span className={`${props.prefixCls}-time`}>{m}</span>
            <span className={`${props.prefixCls}-colon`}>:</span>
            <span className={`${props.prefixCls}-time`}>{s}</span>
            <span className={`${props.prefixCls}-colon`}>:</span>
            <span className={`${props.prefixCls}-time`}>{h}</span>
            <span className={`${props.prefixCls}-time-msg`}>{props.text}</span>
        </div>
    );
};

const PriceComp = (props) => {
    const typeStr: string = `${props.data.promotStatus}${props.data.type}`;
    let text: string = '';
    let classC: string = '';
    if (typeStr === '11') {
        text = '秒杀价';
        classC = `${props.prefixCls}-priceBox1`;
    } else if (typeStr === '12') {
        text = '抢购价';
        classC = `${props.prefixCls}-priceBox2`;
    }
    return (
        <div>
            {
                (props.data.inventory || props.data.stock) &&
                <div className={`${props.prefixCls}-priceBox clearfix ` + classC}>
                    {text} {props.data.preheatPrice && props.data.preheatPrice}
                    {/*<span className={`${props.prefixCls}-priceMsg ` + classC}>{text}</span>*/}
                    {/*<span className={`${props.prefixCls}-price`}>*/}
                        {/*{props.data.preheatPrice && props.data.preheatPrice}*/}
                    {/*</span>*/}
                </div>
            }
        </div>
    );
};

/**
 * 限时组件
 * @class TimeLimit
 * @extends {React.Component<any>}
 */
@observer
class TimeLimit extends React.Component<any, any> {
    static defaultProps = {
        prefixCls: 'time-limit',
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            timeDate: 0
        };
    }

    dataType: any = {
        '11': 'time-limit-bg',
        '12': 'time-limit-bg2',
        '21': 'time-limit-bg3',
        '22': 'time-limit-bg4',
        '01': 'time-limit-bg5',
        '02': 'time-limit-bg6',
    };
    textType: any = {
        '11': '距开始',
        '12': '距结束',
        '21': '距开始',
        '22': '距结束'
    };
    text = {
        '11': '超级秒杀',
        '12': '限时抢购',
        '21': '超级秒杀',
        '22': '限时抢购'
    };
    timer: any = null;

    componentDidMount() {
        let that = this;
        let data: any = this.props.data;
        let timeDate: any = data.promotStatus === 1 ? (data.startTime || 0) : (data.endTime || 0);
        this.setState({
            timeDate: timeDate ? (timeDate - this.props.nowTime) / 1000 : 0
        }, () => {
            that.timeFun();
        });
    }

    @autobind
    timeFun() {
        let that = this;
        if (that.state.timeDate <= 0) {
            return;
        }
        this.timer = setInterval(() => {
            that.setState({
                timeDate: that.state.timeDate - 1
            });
            if (that.state.timeDate <= 0) {
                clearInterval(that.timer);
            }
        }, 1000);
    }

    @autobind
    private _showBg(data: any): string {
        let typeStr;
        if (data.inventory || data.stock) {
            typeStr = `${data.promotStatus}${data.type}`;
        } else {
            typeStr = '0' + data.type;
        }
        return this.dataType[typeStr];
    }

    @autobind
    private _showText(data: any): string {
        const typeStr: string = `${data.promotStatus}${data.type}`;
        return this.textType[typeStr];
    }

    @autobind
    private _showTextMsg(data: any): string {
        const typeStr: string = `${data.promotStatus}${data.type}`;
        return this.text[typeStr];
    }

    render() {
        const {prefixCls, data} = this.props;
        const {timeDate} = this.state;
        const typeStr: string = `${data.promotStatus}${data.type}`;
        return (
            <div className={`${prefixCls} ` + this._showBg(data)}>
                <div className={`${prefixCls}-msg`}>
                    <span className={`${prefixCls}-msgTitle`}>{this._showTextMsg(data)}</span>
                    {
                        data.isForbid !== 1 && typeStr !== '21' && typeStr !== '22' && (
                            <PriceComp
                                {...this.props}
                            />
                        )
                    }
                </div>
                {
                    !data.inventory && !data.stock ?
                        <div className={`${prefixCls}-none`}>已抢光</div>
                        :
                        <TimeComp
                            {...this.props}
                            text={this._showText(data)}
                            date={timeDate}
                        />
                }

            </div>
        );
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }
}

export default TimeLimit;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/activityComp/timeLimit/TimeLimit.tsx